import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import ProductType from "../../../Models/Catalogue/General/ProductType";
import { AppService, Types } from "../../../DomainTypes";
import AuthoriseButton from "../../../Components/AuthoriseButton";
import CatalogueAuthorisation from "../CatalogueAuthorisation";
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";

export default class ProductTypeCatalogueEntry extends CatalogueEntry<ProductType> {

    constructor() {
        super("Product Types", ProductType);

        this.modalSize = "lg";
    }

    private notifications = AppService.get(Types.Neo.UI.GlobalNotifications);

    public get editRole() {
        return CatalogueRoles.ProductType.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.productTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveProductTypes;
    }

    public renderRow(item: ProductType, meta: Model.TransformMetaType<ProductType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.productTypeCode} />
                <NeoGrid.Column bind={meta.productTypeName} />
                <NeoGrid.Column bind={meta.allowImmediateNotice} label="Immediate Notice?" />
                <NeoGrid.Column bind={meta.filterParentInvestment} label="Filter Parent?" 
                    headerTooltip="If ticked, will force investor investments to be linked to issuer investments of the same product type." />
                <NeoGrid.ButtonColumn>
                    <AuthoriseButton
                        className="me-2"
                        viewModel={CatalogueAuthorisation.authorisationVM}
                        currentRecord={item}
                        authoriseRoleName={CatalogueRoles.ProductType.Authorise}
                        onDelete={() => {
                            this.editState.editList.removeWithoutTracking(item);
                            this.dataCache.productTypes.expire();
                        }} />
                </NeoGrid.ButtonColumn>
                <Catalogue.ButtonColumn
                    deleteButton={{
                        onClick: () => {
                            if (item.isNew) {
                                this.editState.editList.removeWithoutTracking(item);
                            }
                            else {
                                item.isPendingDelete = !item.isPendingDelete;
                                if (item.isPendingDelete) {
                                    this.notifications.addInfo("Mark Deleted", `Please click save to action this request.`, NotificationDuration.Standard);
                                }
                            }
                        },
                        icon: item.isPendingDelete ? "trash-restore" : "trash",
                        tooltip: item.isPendingDelete ? "Stop the product type from being removed when authorised."
                                                      : "Mark the product type to be removed when authorised."
                    }} />
            </NeoGrid.Row>
        )
    }
}